export enum Language {
  German = "de",
  English = "en",
  Spanish = "es",
  French = "fr",
  Italian = "it",
  Hindi = "hi",
  Portuguese = "pt",
}

export const allLanguageCodes: Array<Language> = [
  Language.German,
  Language.English,
  Language.Spanish,
  Language.French,
  Language.Italian,
  Language.Hindi,
  Language.Portuguese,
];
// the above is an array of the language codes that will be used for translations

export const defaultLanguage: Language = Language.English; // default language is english

// FlagInterface is for the flag shown in the dropdown for translation
export interface FlagInterface {
  id: string;
  country_code: Language;
  name: string;
  img: string;
}
